
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 .833a9.167 9.167 0 110 18.334A9.167 9.167 0 0110 .833zM10 2.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 6.667c.427 0 .78.321.828.736l.005.097v3.333a.833.833 0 01-1.66.098l-.006-.098V10c0-.46.373-.833.833-.833zm.008-3.334a.833.833 0 01.098 1.661L10 7.5a.833.833 0 01-.097-1.661l.105-.006z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    